import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { addMemberFormField } from '../forms/add-member';
import { ManageEmailService } from '../service/manage-email.service';

@Component({
	selector: 'app-manage-members',
	templateUrl: './manage-members.component.html',
	styleUrls: ['./manage-members.component.scss'],
})
export class ManageMembersComponent implements OnInit {
	members: any = [];
	companyId: any;
	isCanOpenBox = true;
	constructor(
		private manageEmailService: ManageEmailService,
		public popoverController: PopoverController,
	) {}

	ngOnInit() {
		this.members = this.arrangeMembers(this.members);
	}

	deleteMember(id: any) {
		this.manageEmailService.deleteMember(id).subscribe();
	}

	arrangeMembers(members: any) {
		return members.map((membersf: any) => {
			return {
				id: membersf.id,
				name: membersf.firstName + ' ' + membersf.lastName,
				email: membersf.email,
			};
		});
	}

	async addNewMember() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Add Member',
					form: addMemberFormField,
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	onCreate(ref: any, editForm: any) {
		return ref.manageEmailService.addMember(ref.companyId, {
			name: editForm.name,
			email: editForm.email,
		});
	}
}
